import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import DesoResidentTransmitterImage from 'assets/images/deso-resident-transmitter.png';
import G2TransmitterImage from 'assets/images/g2-transmitter.png';
import { DeviceType } from 'shared/models/device-type';

import LinkableTransmitterStepsProviderContext from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/providers/contexts/linkable-transmitter-steps-provider-context';
import styles from './select-type-step.module.scss';

const SelectTypeStep = (): React.JSX.Element => {
  const { t } = useTranslation('deviceTypes');
  const {
    form: { watch, setValue },
    transmitterResidentSettings,
  } = use(LinkableTransmitterStepsProviderContext);
  const selectedType = watch('type');

  const renderTypeCard = (deviceType: DeviceType, imageUrl: string, imageAlt: string): React.JSX.Element => {
    if (!transmitterResidentSettings.includes(deviceType)) {
      return <></>;
    }

    const isSelected = selectedType === deviceType;

    const handleSelect = (): void => setValue('type', deviceType);

    return (
      <button type="button" className={`${styles.typeCard} ${isSelected ? styles.selected : ''}`} onClick={handleSelect}>
        <div className={`${styles.selectionIndicator} ${isSelected ? styles.selected : ''}`}>
          {isSelected && <Check className={styles.checkIcon} />}
        </div>
        <Typography variant="h6">{t(deviceType)}</Typography>
        <img src={imageUrl} alt={imageAlt} />
      </button>
    );
  };

  return (
    <div className={styles.selectTypeStepContainer}>
      {renderTypeCard(DeviceType.DesoResidentTransmitter, DesoResidentTransmitterImage, 'Deso Resident Transmitter')}
      {renderTypeCard(DeviceType.G2Transmitter, G2TransmitterImage, 'G2 Transmitter')}
    </div>
  );
};

export default SelectTypeStep;
